export class GenericTableModel {
	baseUrl: string;
	callbackUrl?: string;
	title?: string;
	globalFilters?: boolean;
	hasAddButton?: boolean;
	addButtonText?: string;
	hasDeleteAction?: boolean;
	hasCustomActions?: boolean;
	showRowsPerPageOptions?: boolean;
	rowsPerPageOptions?: number[];
	showFooter?: boolean;
	classStyles?: string;
	showCurrentPageReport?: boolean;
	currentPageReportTemplate?: string;
	confirmationDialogSize?: string;
	customActions?: any[];
	resultKey? : string;
	stringKey?: string | null;
	extraParams?: any;
	disabled?: boolean;
	hasTabs?: boolean;
	tabsConfiguration?: any;
	urlGetRecordData?: string;
	isCustomRecordData?: boolean;
	createCustomUrl?: any;

	constructor() {
		this.baseUrl = '';
		this.callbackUrl = '';
		this.title = '';
		this.globalFilters = true;
		this.hasAddButton = true;
		this.addButtonText = '';
		this.hasDeleteAction = true;
		this.hasCustomActions = false;
		this.showRowsPerPageOptions = true;
		this.rowsPerPageOptions = [10, 25, 50];
		this.showCurrentPageReport = true;
		this.showFooter = false;
		this.showCurrentPageReport = true;
		this.currentPageReportTemplate = 'Showing {first} to {last} of {totalRecords} entries';
		this.confirmationDialogSize = '50vw';
		this.resultKey = 'data';
		this.disabled = false;
		this.hasTabs = false;
		this.urlGetRecordData = '';
		this.isCustomRecordData = false;
	}

	defaultGetValue(field: any, row: any) {
		return row?.[field.key] ?? null;
	}
}
